import { useTranslation } from '../i18n/TranslationContext';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Button, Box, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { eventApi } from '../services/api';

const DEFAULT_CONTENT =
  '<h3>Cosa sono i cookie</h3>' +
  '<p>I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo ' +
  'dell’utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti in ' +
  'occasione di visite successive. Possono essere installati dal gestore del sito oppure ' +
  'da soggetti terzi (cosiddetti cookie di terze parti).</p>' +
  '<h3>Cookie tecnici</h3>' +
  '<p>Sono utilizzati al solo fine di effettuare la trasmissione di una comunicazione ' +
  'elettronica o nella misura strettamente necessaria a fornire il servizio richiesto ' +
  '(es. memorizzare la scelta espressa sui cookie). Per il loro utilizzo non è richiesto ' +
  'il consenso dell’utente (art. 122 del Codice Privacy, D.Lgs. 196/2003).</p>' +
  '<h3>Cookie di analisi e di profilazione</h3>' +
  '<p>Previo tuo consenso, questo sito può utilizzare strumenti di analisi e di ' +
  'tracciamento di terze parti — quali Google Analytics 4, Google Ads, Google Tag Manager ' +
  'e Meta (Facebook) Pixel — per misurare le visite, analizzare l’utilizzo delle pagine e ' +
  'valutare l’efficacia delle campagne pubblicitarie. Tali strumenti vengono attivati ' +
  'esclusivamente dopo l’accettazione tramite il banner e comportano il trattamento di ' +
  'dati da parte dei rispettivi fornitori, secondo le loro informative privacy.</p>' +
  '<h3>Base giuridica del trattamento</h3>' +
  '<p>La base giuridica per l’uso dei cookie diversi da quelli tecnici è il consenso ' +
  'dell’interessato (art. 6, par. 1, lett. a del Regolamento UE 2016/679 – GDPR), ' +
  'liberamente prestato e revocabile in qualsiasi momento.</p>' +
  '<h3>Come gestire o revocare il consenso</h3>' +
  '<p>Se non accetti, la navigazione prosegue con i soli cookie tecnici. Puoi modificare o ' +
  'revocare la scelta in qualsiasi momento eliminando i cookie dalle impostazioni del tuo ' +
  'browser: alla visita successiva il banner verrà riproposto. Puoi inoltre gestire o ' +
  'disattivare i cookie direttamente dalle impostazioni del browser.</p>' +
  '<h3>Diritti dell’interessato</h3>' +
  '<p>Ai sensi degli artt. 15-22 del GDPR hai il diritto di ottenere l’accesso ai tuoi dati ' +
  'personali, la rettifica, la cancellazione, la limitazione del trattamento, nonché di ' +
  'opporti al trattamento e di richiedere la portabilità dei dati. Hai inoltre il diritto ' +
  'di proporre reclamo al Garante per la protezione dei dati personali ' +
  '(www.garanteprivacy.it).</p>' +
  '<h3>Titolare del trattamento</h3>' +
  '<p>Titolare del trattamento è il soggetto organizzatore dell’evento e gestore del ' +
  'presente sito, i cui riferimenti e recapiti sono indicati nelle pagine dell’evento. ' +
  'Per esercitare i tuoi diritti puoi utilizzare i recapiti ivi riportati.</p>';

const readLastEventSlug = (): string | null => {
  try {
    return sessionStorage.getItem('last_event_slug');
  } catch {
    return null;
  }
};

const CookiePolicyPage: React.FC = () => {
  const { t, lang } = useTranslation();
  const navigate = useNavigate();
  const [content, setContent] = useState<string | null>(null);
  const [title, setTitle] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const lastEventSlug = readLastEventSlug();

  useEffect(() => {
    eventApi
      .getCookieBanner(lang)
      .then((data) => {
        if (data?.policy_content) {
          setContent(data.policy_content);
        }
        if (data?.title) {
          setTitle(data.title);
        }
      })
      .catch(() => undefined)
      .finally(() => setLoading(false));
  }, [lang]);

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        {lastEventSlug && (
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(`/event/${lastEventSlug}`)}
            sx={{ mb: 2 }}
          >
            {t('cookie.torna_evento', "Torna all'evento")}
          </Button>
        )}
        <Typography variant="h4" component="h1" gutterBottom>
          {title || t('cookie.titolo', 'Informativa cookie')}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{ '& p': { mb: 2 }, '& h3': { mt: 3, mb: 1, fontSize: '1.1rem' } }}
            dangerouslySetInnerHTML={{ __html: content || t('cookie.policy_default', DEFAULT_CONTENT) }}
          />
        )}
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          {t('cookie.torna_indietro', 'Torna indietro')}
        </Button>
      </Paper>
    </Container>
  );
};

export default CookiePolicyPage;
